// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_ModeloInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /contratos/modelo_salvar — grava uma versão nova do modelo padrão (Full). */
import type { Contratos_ClausulaRow } from './Contratos_ClausulaRow'
import { registerContract } from './validate'

export interface Contratos_ModeloInput {
clausulas?: Contratos_ClausulaRow[]
}

registerContract('Contratos_ModeloInput', {
  clausulas: {
    type: 'array',
    required: false,
    items: {
      chave:  { type: 'string',  required: false },
      titulo: { type: 'string',  required: false },
      texto:  { type: 'string',  required: false },
      fixa:   { type: 'boolean', required: false },
    },
  },
})
